import React from "react";

import { Operator } from "store/types";
import { Typography } from "@mui/material";
import { featureToggles } from "config/featureToggles";

const headers: Record<Operator, string> = {
  [Operator.NOT]: "Not:",
  [Operator.OR]: "Either:",
  [Operator.XOR]: "One of:",
  [Operator.AND]: "",
  [Operator.IF]: "If",
};

const linkWords: Record<Operator, (n?: number) => string> = {
  [Operator.NOT]: () => "",
  [Operator.OR]: () => "Or",
  [Operator.XOR]: () => "Or",
  [Operator.AND]: () => "",
  [Operator.IF]: (n) => (n === 0 ? "Then" : ""),
};

interface IOperatorProps {
  operator?: Operator | null;
  level: number;
}

interface IOperatorHeaderProps extends IOperatorProps {
  numOperands: number;
}

interface IOperatorLinkProps extends IOperatorProps {
  index: number;
}

export const OperatorHeader = ({ operator, numOperands }: IOperatorHeaderProps) => {
  if (featureToggles.bracketConnectors) {
    return null;
  }
  if (numOperands <= 1 && operator !== Operator.NOT) {
    return null;
  }
  const header = operator && headers[operator];
  return header ? <Typography sx={{ fontWeight: "bold" }}>{header}</Typography> : null;
};

export const OperatorLink = ({ operator, index }: IOperatorLinkProps) => {
  if (featureToggles.bracketConnectors) {
    return null;
  }
  const link = operator && linkWords[operator](index);
  return link ? <Typography sx={{ fontWeight: "bold" }}>{link}</Typography> : null;
};
